/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReminderSettingsV1Dto = {
  /**
   * The interval in days between reminders
   */
  interval_in_days: ReminderSettingsV1Dto.interval_in_days;
  /**
   * The maximum number of reminders
   */
  max_occurrences: ReminderSettingsV1Dto.max_occurrences;
};
export namespace ReminderSettingsV1Dto {
  /**
   * The interval in days between reminders
   */
  export enum interval_in_days {
    '_1' = 1,
    '_2' = 2,
    '_7' = 7,
    '_14' = 14,
  }
  /**
   * The maximum number of reminders
   */
  export enum max_occurrences {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
  }
}
